export enum PreloadType {
  None = 'none',
  /**
   * new 를 이용한 인스턴스 캐시. 모바일 사파리에선 지원하지 않는다.
   */
  Instance = 'instance',
  /**
   * data-uri 로 컨버팅. 다운로드 기능시 사용
   */
  DataConverted = 'data-converted',
}
